<template>
  <div>
    <app-form
      :form-data="form_config"
      @confirm="confirm"
      @cancel="cancel"
    />
  </div>
</template>

<script>
export default {
  components: {
    'app-form': () => import('@/components/app-form'),
  },
  data() {
    return {
      form_config: require('./model/form-config')(this),
    };
  },
  methods: {
    confirm(params) {
      this.$emit('confirm', params);
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>
